// extracted by mini-css-extract-plugin
export var alertIcon = "_uz-0";